(() => {
  if (window.sbKaraLeadgen) { window.sbKaraLeadgen.boot(document); return; }
  const active = new Map();
  const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  function places(root) {
    root.querySelectorAll('[data-sb-places]').forEach(box => {
      const total = Math.max(0, number(box.dataset.total));
      const initial = Math.max(0, number(box.dataset.initial));
      const minimum = Math.min(total, Math.max(0, number(box.dataset.minimum)));
      let remaining = number(box.dataset.manual);
      const start = Date.parse(box.dataset.start);
      if (box.dataset.mode === 'automatic' && Number.isFinite(start)) {
        const intervalHours = Math.max(1, number(box.dataset.intervalHours, 6));
        const step = Math.min(100, Math.max(0, number(box.dataset.step, 2)));
        const elapsed = Math.max(0, Date.now() - start);
        const intervals = Math.floor(elapsed / (intervalHours * 3600000));
        const initialRemaining = Math.min(total, Math.max(minimum, initial));
        const initialPercentage = total > 0 ? (total - initialRemaining) / total * 100 : 0;
        const maxPercentage = total > 0 ? (total - minimum) / total * 100 : 0;
        const currentPercentage = Math.min(maxPercentage, initialPercentage + intervals * step);
        remaining = Math.max(minimum, Math.round(total * (1 - currentPercentage / 100)));
      }
      remaining = Math.min(total, Math.max(0, remaining));
      const registered = total - remaining;
      const percentage = total ? registered / total * 100 : 0;
      const formatter = new Intl.NumberFormat('fr-FR');
      root.querySelectorAll('[data-registered]').forEach(el => el.textContent = formatter.format(registered));
      box.querySelectorAll('[data-remaining]').forEach(el => el.textContent = formatter.format(remaining));
      const bar = box.querySelector('[data-progress]');
      if (bar) bar.style.width = percentage + '%';
      const track = box.querySelector('[role=progressbar]');
      if (track) track.setAttribute('aria-valuenow', String(Math.round(percentage)));
    });
  }
  let campaignObserver;
  function hideGorgias() {
    try { window.GorgiasChat?.hideChat?.(true); } catch {}
  }
  window.addEventListener('gorgias-widget-loaded', hideGorgias);
  hideGorgias();
  function hideCampaignTeaser() {
    if (!document.querySelector('.sb-lg-hero')) return;
    const campaignText = /gagne\s*3\s*mois\s*de\s*cure/i;
    for (const element of document.body.querySelectorAll('*')) {
      if (!campaignText.test(element.textContent || '') || element.closest('.sb-lg-signup,script,style,.sb-lg-hidden-campaign')) continue;
      if ([...element.children].some(child => campaignText.test(child.textContent || ''))) continue;
      let target = null;
      for (let parent = element; parent && parent !== document.body; parent = parent.parentElement) {
        if (getComputedStyle(parent).position === 'fixed') { target = parent; break; }
      }
      target ||= element.closest('button,[role="button"]');
      if (target) target.classList.add('sb-lg-hidden-campaign');
    }
  }
  function observeCampaign() {
    hideCampaignTeaser();
    if (campaignObserver || !document.querySelector('.sb-lg-hero')) return;
    let scheduled = false;
    campaignObserver = new MutationObserver(records => {
      if (records.every(record => (record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement)?.closest('[data-time],[data-registered],[data-remaining]'))) return;
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; hideCampaignTeaser(); });
    });
    campaignObserver.observe(document.body, {childList: true, characterData: true, subtree: true});
  }
  function boot(scope = document) {
    observeCampaign();
    scope.querySelectorAll('[data-sb-leadgen]').forEach(root => {
      if (active.has(root)) return;
      const tick = () => {
        const sharedTimer = document.querySelector('.sb-ty-timer[data-event-date]');
        const deadline = Date.parse(root.dataset.syncTimer === 'false' ? root.dataset.deadline : sharedTimer?.dataset.eventDate || root.dataset.deadline);
        const total = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        const values = {days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, hoursTotal: Math.floor(total / 3600), minutes: Math.floor(total / 60) % 60, seconds: total % 60};
        root.querySelectorAll('[data-time]').forEach(el => el.textContent = Number.isFinite(deadline) ? String(values[el.dataset.time]).padStart(2, '0') : '—');
        places(root);
      };
      tick();
      const timer = setInterval(() => {
        if (!root.isConnected) { clearInterval(timer); active.delete(root); return; }
        tick();
      }, 1000);
      active.set(root, timer);
    });
  }
  document.addEventListener('click', event => {
    const summary = event.target.closest('.sb-lg-faq-item > summary');
    if (summary && !summary.parentElement.open) {
      summary.closest('.sb-lg-faq').querySelectorAll('.sb-lg-faq-item[open]').forEach(item => { item.open = false; });
    }
    const link = event.target.closest('[data-vip-link]');
    if (!link || !link.hash) return;
    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    const email = target?.matches('.sb-lg-hero') ? null : target?.matches('input[type=email]') ? target : target?.querySelector('input[type=email]');
    if (!target) return;
    event.preventDefault();
    (email || target).scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
    (email || target).focus({preventScroll: true});
  });
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    active.forEach((timer, root) => { if (event.target.contains(root)) { clearInterval(timer); active.delete(root); } });
  });
  window.sbKaraLeadgen = {boot};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
})();
